import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FiCheck } from 'react-icons/fi';
import { HOME_EASE, HomeFloat } from './HomeMotion';
import projectsPhoto from '../../../images/home/projects-photo.png';

const STEPS = [
  { name: 'Planning', date: 'Oct 6', status: 'Complete', state: 'complete' },
  { name: 'Design', date: 'Oct 20', status: 'Complete', state: 'complete' },
  { name: 'Development', date: 'Nov 3', status: 'In Progress', state: 'current' },
  { name: 'Testing', date: 'Nov 17', status: 'Upcoming', state: 'upcoming' },
  { name: 'Launch', date: 'Dec 1', status: 'Upcoming', state: 'upcoming' },
];

const HomeProjectVisual = () => {
  const reduce = useReducedMotion();

  return (
    <div className="home-project-stage">
      <div className="home-project-photo-wrap">
        <motion.img
          src={projectsPhoto}
          alt="Team collaborating on a project in flowdo"
          className="home-project-photo"
          draggable="false"
          initial={reduce ? false : { opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.28 }}
          transition={{ duration: 0.7, ease: HOME_EASE }}
        />
      </div>

      <HomeFloat
        className="home-float--project-timeline"
        cardClassName="home-float-card--project-timeline"
        enterDelay={0.2}
        inView
        drift={{ x: 3, y: -8, duration: 5.8, durationX: 7.2 }}
      >
        <p className="home-project-timeline-title">Project Timeline</p>
        <div className="home-project-steps">
          <span className="home-project-track" aria-hidden="true">
            <motion.i
              className="home-project-track-done"
              initial={reduce ? false : { width: 0 }}
              whileInView={{ width: '50%' }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 1.05, delay: 0.35, ease: HOME_EASE }}
            />
          </span>
          {STEPS.map((step, index) => (
            <motion.div
              key={step.name}
              className={`home-project-step is-${step.state}`}
              initial={reduce ? false : { opacity: 0, y: 6 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.28 + index * 0.12, ease: HOME_EASE }}
            >
              <span className="home-project-step-name">{step.name}</span>
              <span className="home-project-node">
                {step.state === 'complete' ? <FiCheck /> : null}
                {step.state === 'current' ? <i /> : null}
              </span>
              <span className="home-project-step-date">{step.date}</span>
              <span className="home-project-step-status">{step.status}</span>
            </motion.div>
          ))}
        </div>
      </HomeFloat>
    </div>
  );
};

export default HomeProjectVisual;
